import React, { useEffect, useState } from 'react'

import {
  Popover,
  PopoverHandler,
  PopoverContent,
  Button
} from '@material-tailwind/react'

import { CiFilter } from 'react-icons/ci'
import { router, usePage } from '@inertiajs/react'
import { usePrevious } from 'react-use'
import pickBy from 'lodash/pickBy'
import { MdOutlineFileDownload } from 'react-icons/md'
import Select from 'react-tailwindcss-select'
import { GrPowerReset } from 'react-icons/gr'
import { RiFileDownloadFill } from 'react-icons/ri'

import DatePicker from '@/Shared/DatePicker'

export default function ({ exportRoute, reportRoute }) {
  const {
    filters,
    hospitals,
    packages,
    firms,
    auth: {
      user: { role }
    }
  } = usePage().props

  const [values, setValues] = useState({
    hospital_id: filters.hospital_id || '',
    firm: filters.firm || '',
    package: filters.package || '',
    startDate: filters.startDate || '',
    endDate: filters.endDate || ''
  })

  const prevValues = usePrevious(values)

  useEffect(() => {
    if (prevValues) {
      const query = Object.keys(pickBy(values)).length
        ? pickBy(values)
        : { remember: 'forget' }
      router.get(route(route().current(), route().params), query, {
        replace: true,
        preserveState: true
      })
    }
  }, [values])

  function reset() {
    setValues({
      hospital_id: '',
      firm: '',
      package: '',
      startDate: '',
      endDate: ''
    })
  }

  return (
    <Popover placement="bottom">
      <PopoverHandler>
        <Button size="sm" type="button" variant="text">
          <CiFilter size={25} />
        </Button>
      </PopoverHandler>

      <PopoverContent>
          <div className="mb-4 flex items-center justify-center gap-x-2">
              <a
                  href='#'
                  type="button"
                  color="blue-gray"
                  onClick={reset}
                  className="mb-1 flex items-center gap-2 rounded-lg p-2 text-sm font-semibold hover:bg-blue-gray-500/10 active:bg-blue-gray-500/30"
              >
                  <GrPowerReset size={20} /> Reset
              </a>

              <a
                  href={route(exportRoute, {
                      ...values,
                      search: filters.search || '',
                      trashed: filters.trashed || ''
                  })}
                  type="button"
                  color="blue-gray"
                  className="mb-1 flex items-center gap-2 rounded-lg p-2 text-sm font-semibold hover:bg-blue-gray-500/10 active:bg-blue-gray-500/30"
              >
                  <MdOutlineFileDownload size={25} /> Export
              </a>

              <a
                  href={route(reportRoute, {
                      ...values,
                      search: filters.search || '',
                      trashed: filters.trashed || ''
                  })}
                  type="button"
                  color="blue-gray"
                  className="mb-1 flex items-center gap-2 rounded-lg p-2 text-sm font-semibold hover:bg-blue-gray-500/10 active:bg-blue-gray-500/30"
              >
                  <RiFileDownloadFill size={25} /> Report
              </a>
          </div>

          <div className="flex flex-col gap-4">
              {role === '1' && hospitals?.length > 0 && (
                  <Select
                      label="Select Hospital"
                      name="hospital_id"
                      primaryColor="indigo"
                      value={
                          values.hospital_id && {
                              value: values.hospital_id,
                              label: hospitals?.find(
                                  hospital => hospital.id == values.hospital_id
                              )?.name
                }
              }
              isSearchable
              options={hospitals?.map(hospital => ({
                label: hospital.name,
                value: hospital.id
              }))}
              onChange={option =>
                setValues(prev => ({
                  ...prev,
                  hospital_id: option.value
                }))
              }
            />
          )}

          {packages?.length > 0 && (
            <Select
              label="Select Package"
              name="package"
              primaryColor="indigo"
              value={
                values.package && {
                  value: values.package,
                  label: values.package
                }
              }
              isSearchable
              options={packages.map(pack => ({
                value: pack,
                label: pack
              }))}
              onChange={option =>
                setValues(prev => ({
                  ...prev,
                  package: option.value
                }))
              }
            />
          )}

          {firms?.length > 0 && (
            <Select
              label="Select Firm"
              name="firm"
              primaryColor="indigo"
              value={
                values.firm && {
                  value: values.firm,
                  label: values.firm
                }
              }
              isSearchable
              options={firms?.map(firm => ({
                value: firm,
                label: firm
              }))}
              onChange={option =>
                setValues(prev => ({
                  ...prev,
                  firm: option.value
                }))
              }
            />
          )}

          <DatePicker
            label="Select Start Date"
            date={values.startDate}
            maxDate={values.endDate}
            setDate={date =>
              setValues(prev => ({
                ...prev,
                startDate: date
              }))
            }
          />

          <DatePicker
            label="Select End Date"
            date={values.endDate}
            minDate={values.startDate}
            setDate={date =>
              setValues(prev => ({
                ...prev,
                endDate: date
              }))
            }
          />
        </div>
      </PopoverContent>
    </Popover>
  )
}
